import Modal from '@cosmos/hmodal';
import React from 'react';
import { MODAL_VIEW_TYPES } from './constants';
interface Props {
  isOpen: boolean;
  onClose: any;
  classes?: string;
  children: React.ReactNode;
}
const ModalComponent: React.FC<Props> = ({
  classes = '',
  isOpen,
  onClose,
  children,
}) => {
  return (
    <div>
      <Modal
        appElementId={'appElement'}
        className={classes}
        portalClassName={'dialogModalModalPortal'}
        viewType={MODAL_VIEW_TYPES.DIALOG}
        isOpen={isOpen}
        openingAnimation={true}
        closeButtonEnabled
        scrollLock={true}
        onClose={() => onClose(false)}
        shouldCloseOnOverlayClick={false}
      >
        {children}
      </Modal>
    </div>
  );
};

export default ModalComponent;
